import aiDraftShared from '@/locales/fr-CA/aiDraftShared.js';

export default {
    attachmentPreview: 'Aperçu',
    archive: 'Archiver la conversation',
    archived: 'Archivée',
    conversationDetails: 'Détails de la conversation',
    restoreConversation: 'Restaurer la conversation',
    notifications: {
        smsNotLoading: 'Erreur lors du chargement des SMS.',
        parseTemplateFailed: 'Échec de l’analyse du modèle.',
        noMobileNumber: "{lead} n'a aucun téléphone mobile.",
        smsProviderUnavailable:
            'Aucun numéro SMS n’est configuré pour ce compte. Veuillez contacter le support pour en ajouter un.',
        searchingExistingConversation:
            'Une erreur est survenue lors de la recherche de conversation existante avec {lead}.',
        archiveFailed: 'Échec de l’archivage de la conversation.',
        unarchiveFailed: 'Échec de la restauration de la conversation.',
        conversationArchivedSuccess: 'Conversation archivée avec succès.',
        conversationUnarchivedSuccess: 'Conversation restaurée avec succès.',
        smsSendFailed: 'Échec de l’envoi du SMS.',
        attachmentSendFailed: "Échec de l'envoi de la pièce jointe.",
        unsupportedFileType:
            '{name} : type de fichier non pris en charge. Seuls les fichiers GIF, JPEG, PNG et PDF sont acceptés.',
        noOutgoingProvider: 'Aucun fournisseur de téléphone sortant configuré pour les SMS.',
        providerPhoneNotConfigured:
            "Le numéro de téléphone du fournisseur SMS n'est pas configuré.",
        phoneNotFound: "Le numéro de téléphone sélectionné n'a pas été trouvé pour ce lead.",
        conversationLoadFailed: 'Échec du chargement de la conversation. Veuillez réessayer.',
    },
    errors: {
        no_sms_provider_available:
            'Tous les numéros de concession sont déjà utilisés pour ce téléphone du client.',
        lead_unsubscribed: "Ce lead s'est désabonné des communications SMS.",
        casl_expired: "Impossible d'envoyer un SMS : le consentement client est expiré.",
        sms_communication_disabled: "La communication par SMS n'est pas disponible pour ce lead.",
        unableToLoadConversation:
            'Impossible de charger la conversation. Veuillez réessayer plus tard.',
    },
    readOnlyConversation: 'Cette conversation est en lecture seule.',
    smsProviderInactive:
        "Ce numéro de concession est inactif et ne permet plus d'envoyer de nouveaux messages.",
    sendUnavailable: "L'envoi de SMS n'est pas disponible pour cette conversation.",
    filter: {
        active: 'Actives',
        all: 'Toutes les conversations',
        archived: 'Archivées',
        title: 'Afficher les conversations',
        intelligentFilter: 'Filtre intelligent',
        intelligentFilterTooltip:
            "Lorsqu'il est actif, les conversations composées uniquement de confirmations de rendez-vous, de messages de campagnes et des mots-clés 'OUI', 'NON' et 'STOP' ne seront pas affichées",
    },
    group: 'GROUPE',
    hasMultiplePhones:
        'a plusieurs numéros de téléphone. Choisissez-en un pour démarrer la conversation.',
    historicalPhoneMismatch:
        'Le numéro utilisé pour cette activité ne correspond plus aux données actuelles du client. Il ne peut pas être sélectionné.',
    selectCurrentPhone: 'Sélectionnez un numéro mobile actuel pour {lead} afin de continuer.',
    attachments: 'Pièces jointes',
    documents: 'Documents',
    images: 'Images',
    messages: 'Messages',
    newConversation: 'Nouvelle conversation',
    peopleInChat: 'Personnes dans le chat',
    redirectToLead: 'Rediriger vers le lead',
    removeAttachment: 'Supprimer',
    searchEmojis: 'Rechercher des emojis',
    searchPlaceholder: 'Rechercher un client ou un numéro de téléphone',
    selectPhone: 'Sélectionner un numéro de téléphone',
    sentFromDealerPhone: 'Envoyé depuis: {phone}',
    smsInputPlaceholder: 'Tapez votre message ici...',
    template: {
        category: 'Catégorie',
        insert: 'Insérer',
        insertEn: 'Insérer (EN)',
        insertFr: 'Insérer (FR)',
        noResults: 'Aucun modèle trouvé.',
        searchPlaceholder: 'Rechercher un message...',
        selectCategory: 'Sélectionner une catégorie',
        table: {
            name: 'Nom',
            category: 'Catégorie',
            message_en: 'Message (EN)',
            message_fr: 'Message (FR)',
        },
        title: 'Insérer un modèle',
    },

    pagination: {
        paused: 'Chargement en pause. Vous pouvez charger plus de résultats.',
        loadMore: 'Charger plus',
    },
    conversationsList: {
        failedToLoad: 'Échec du chargement des conversations.',
        noResults: 'Aucun résultat',
        timestamp: {
            justNow: "À l'instant",
            minsAgo: 'Il y a {count} min | Il y a {count} min',
            hoursAgo: 'Il y a {count} heure | Il y a {count} heures',
        },
    },
    messagesList: {
        failedToLoad: 'Échec du chargement des messages.',
        failedToDownloadAttachment: 'Échec du téléchargement de la pièce jointe.',
        unreadSeparator: 'Messages non lus',
        newMessages: '{count} nouveau message | {count} nouveaux messages',
    },
    message: {
        notDelivered: 'Non livré',
        notDeliveredWithRetry: 'Non livré. Cliquez pour réessayer.',
        notDeliveredNoAccess: 'Non autorisé',
        notDeliveredUnreachable: 'Ce numéro est une ligne fixe ou injoignable',
        notDeliveredUnreachableWithRetry:
            "Ce numéro n'a pas pu être joint. Cliquez pour réessayer.",
        error: 'Une erreur est survenue. Cliquez pour réessayer.',
        errorNoAccess: "Vous n'avez pas les droits d'écrire à ce contact.",
        retryFailed: 'Échec de la tentative de renvoi du message. Veuillez réessayer.',
    },
    dateSeparator: {
        today: "Aujourd'hui",
        yesterday: 'Hier',
    },
    appointment: {
        confirmed: 'Rendez-vous confirmé',
        canceled: 'Rendez-vous annulé',
        pending: 'En attente de confirmation',
    },
    consentExpired: 'Consentement du client expiré',
    consentExpiredMessage:
        'Sans le consentement explicite du client, la Loi canadienne anti-pourriel vous empêche de communiquer avec lui de façon électronique.',
    customerUnsubscribed: 'Client désabonné',
    unsubscribedMessage:
        'Le contact doit se réabonner aux communications SMS pour vous permettre de lui envoyer des messages.\nPour ce faire, il lui suffit d\'envoyer "UNSTOP" au {phoneNumber}',
    aiDraft: {
        ...aiDraftShared,
        rateLimit: "Limite d'utilisation de l'IA atteinte. Veuillez attendre {emphasis}",
        rateLimitEmphasis: '{seconds} secondes avant de réessayer.',
        smsTextLimitReached: 'Limite de {limit} caractères atteinte.',
        undo: 'Annuler',
        updateInstructionLabel: 'Décrivez vos changements',
        updateInstructionLimitReached: 'Limite de 255 caractères atteinte.',
        updateInstructionPlaceholder: 'Décrivez vos changements',
        updateServiceLeadUnavailable:
            'La mise à jour avec IA est disponible seulement pour les leads de vente.',
        updateWithAi: 'Mettre à jour avec IA',
    },
};
